var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#58AB27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.864,13.264l-0.03,0.042l-2.099,2.933l-0.001,0L37.44,89.279c-0.885,1.236-2.283,2.002-3.8,2.083 c-0.089,0.005-0.177,0.007-0.266,0.007c-1.422,0-2.783-0.606-3.734-1.676L4.604,61.569c-0.072-0.081-0.142-0.164-0.208-0.249 c-3.344-4.288-2.808-10.387,1.22-13.883l6.556,7.551l0,0.001c0.024,0.013,0.028,0.048,0.067,0.116l20.713,23.268l50.782-70.93 c1.609-2.246,4.73-2.761,6.976-1.155C92.953,7.895,93.471,11.018,91.864,13.264z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9149926bc95c8faf1ebeb02dac03a947.svg";
export { ForwardRef as ReactComponent };